import styled from 'styled-components';
export const Wrapper = styled.div `
  margin-top: 3rem;
  
  .form__group {
    margin-bottom: 0;
  }
`;
export const PromoWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;
export const Details = styled.details `
  border: 0.1rem solid var(--border);
  border-radius: var(--border-radius-sm);
  padding: 1.5rem;
  width: 100%;

  &[open] {
    summary::after {
      transform: rotate(180deg);
    }
  }
  
  summary {
    
  }
  
  .form {
    margin-top: 1.5rem;
  }
`;
export const Summary = styled.summary `
  position: relative;
  list-style: none;
  
  &::marker {
  display: none;
  }

  > summary::-webkit-details-marker {
    display: none;
  }
  
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0.3rem;
    right: 0;
    width: 1.4rem;
     height: 1.4rem;
    //height: auto;
    background: url("/assets/images/icon--chevron-curvy.png") no-repeat center;
    //transform: rotate(270deg);
    background-size: auto 1.4rem;
  }
`;
export const Title = styled.span `
  user-select: none;
`;
export const Copy = styled.span `
  color: var(--text);
  display: block;
  font: var(--paragraph-font);
  margin-top: 0.5rem;
  user-select: none;
`;
export default {
    Wrapper,
    Details,
    Title,
    Copy,
};
